export default "__VITE_ASSET__DgbpwDcS__"